<template>

  <div>
    
    <h1>{{$t('Change password')}}</h1>

    <div class="flex">
      <p>
        {{$t('pwd-intro')}}
      </p>
    </div>

    <form @submit.prevent="changePassword" v-if="!changedDone">

      <p>
        <label for="pass_old">
          <span>{{$t('Your current password')}}:</span>
          <input type="password" name="pass_old" id="pass_old" :placeholder="$t('Your current password')" required  v-model="oldPass" />
          <span class="error" for="pass_old" v-show="oldPassError !== ''">{{oldPassError}}</span>
        </label>
      </p>
      <p>
        <label for="pass_new">
          <span>{{$t('New password')}}:</span>
          <input type="password" name="pass_new" id="pass_new" :placeholder="$t('New password')" required  v-model="newPass" />
          <span class="error" for="pass_new" v-show="newPassError !== ''">{{newPassError}}</span>
        </label>
      </p>
      <p>
        <label for="pass_newconfirm">
          <span>{{$t('Confirm new password')}}:</span>
          <input type="password" name="pass_newconfirm" id="pass_newconfirm" :placeholder="$t('Confirm new password')" required  v-model="newPassConfirmation" />
          <span class="error" for="pass_newconfirm" v-show="confirmPassError !== ''">{{confirmPassError}}</span>
        </label>
      </p>
      
      <p>
        <input type="submit" :value="$t('Update password')" class="btn_blue">
      </p>

      <span class="error" v-show="changeError">
        {{$t('An error occurred')}}: <strong>{{changeError}}</strong>
      </span>

    </form>

    <div v-if="changedDone">
      <p>
        {{$t('Okay, your password has been correctly changed.')}}
        <br /><br />
        <a href="/">{{$t('Go back to app')}}</a>
      </p>
    </div>

  </div>

</template>

<script>

import { Auth } from 'aws-amplify'

export default {
  name: 'ChangePassword',

  metaInfo () { 
    return { title: this.$t("meta-title") } 
  },
  
  data: function() {
    return {
      oldPass : '',
      newPass : '',
      oldPassError : '',
      newPassError : '',
      newPassConfirmation : '',
      confirmPassError : '',
      wait : false,
      changeError: '',
      changedDone : false,
    }
  },
  methods:
  {
    
    async changePassword() {

      if (this.newPass !== this.newPassConfirmation) {
        this.newPassError = this.$t('New password and confirmation does not match.')
        this.confirmPassError = this.$t('New password and confirmation does not match.')
      }
      else {

        try {
          
          this.hasError = false
          this.changeError = ''

          const usr = await Auth.currentAuthenticatedUser()
          await Auth.changePassword(usr, this.oldPass, this.newPass)
          .then(data => console.log(data))
          .catch(err => {
            throw err  
          })
  
          this.changedDone = true

          window.analytics.track('user-pwdchanged')

        } catch (error) {

          window.analytics.track('user-pwdchanged-error', error)

          this.changedDone = false

          if (error.message != "") this.changeError = error.message
          else this.changeError = this.$t('An error occurred, please check the data entered and try again')
        }

      }


    }

  },
  async mounted(){

    try {
      const usr = await Auth.currentAuthenticatedUser()
    } catch (error) {
      this.$router.replace('/login?returnUrl=/change-password')
    }
    
  }
  
}
</script>



<i18n>
{
  "en" : {
    "meta-title" : "Winerz  |  Change password",
    "Change password": "Change password",
    "pwd-intro": "Here you can change your password. Please enter your current password and a new one to confirm the update.",
    "Your current password": "Your current password",
    "New password": "New password",
    "Confirm new password": "Confirm new password",
    "Update password": "Update password",
    "An error occurred": "An error occurred",
    "Okay, your password has been correctly changed.": "Okay, your password has been correctly changed.",
    "Go back to app": "Go back to app",
    "New password and confirmation does not match.": "New password and confirmation does not match.",
    "An error occurred, please check the data entered and try again": "An error occurred, please check the data entered and try again"
  },
  "fr" : {
    "meta-title" : "Winerz  |  Changer le mot de passe",
    "Change password": "Changement du mot de passe",
    "pwd-intro": "Tu peux changer ici ton mot de passe. Entre ton mot de passe actuel puis choisis en un nouveau :",
    "Your current password": "Mot de passe actuel",
    "New password": "Nouveau mot de passe",
    "Confirm new password": "Confirme le nouveau mot de passe",
    "Update password": "Mettre à jour",
    "An error occurred": "Une erreur s'est produite",
    "Okay, your password has been correctly changed.": "Ok, ton mot de passe a bien été changé",
    "Go back to app": "Retour à l'app",
    "New password and confirmation does not match.": "Le nouveau mot de passe et sa confirmation ne correspondent pas",
    "An error occurred, please check the data entered and try again": "Une erreur est survenur, merci de vérifier ta saisie avant de recommencer."
  }
}
</i18n>